import { graphql } from '../../../gql';

export const CREATE_CIRCLE = graphql(`
  mutation createCircle($input: CreateCircleInput!) {
    createCircle(input: $input) {
      ...CircleFields
    }
  }
`);
